import Vue from 'vue';
import axios from "axios";
import Configuration from "../configuration";

// Set base URL
axios.defaults.baseURL = `${Configuration.value("rootApi")}/api`;

// Request interceptor
axios.interceptors.request.use(config => {
    config.headers.Authorization = window.localStorage.getItem('accessToken');
    config.headers.Accept = 'application/json';
    return config;
});

// Response interceptor
axios.interceptors.response.use(
    (response) => {
        // Handle successful responses
        return response;
    },
    async (error) => {
        // Handle errors
        if (!error.response) {
           // Vue.swal('Veuillez vérifier votre connexion', '', 'error')
        } else {
            // For blob responses, we need to read the blob as text
            if (error.response.data instanceof Blob) {
                try {
                    const jsonText = await error.response.data.text();
                    const errorData = JSON.parse(jsonText);
                    Vue.swal('Oops', errorData.message || 'Error Occurred', 'error');
                } catch (e) {
                    console.error('Error parsing blob response:', e);
                    Vue.swal('Oops', 'Error Occurred', 'error');
                }
            } else {
                // Normal JSON error handling
                Vue.swal('Oops', error.response.data.message || 'Error Occurred', 'error');
            }
            console.log(error);
        }
        return Promise.reject(error);
    }
);

export default axios;